import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Member Cars';
moduleConfig.singleItemTitle = 'Member Car';
moduleConfig.url = 'member-cars';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Archive Selected",
        value: "Archive"
    },
    {
        displayName: "Restore Selected",
        value: "Restore"
    },
    {
        displayName: "Resolve Conflict for Selected",
        value: "Resolve-Conflict"
    },
];


export default moduleConfig;